module.exports = __webpack_public_path__ + "static/media/flag-et.9d406f5c.webp";